import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";
import { ITextBuilder } from "../../../../../Global/Base/Builders/ITextBuilder";
import { Event } from "../../../../../Global/Base/Events";
import { EMPTY_ITEM_RIGHTS_COLLECTION } from "../../../../../Global/Base/Rights/RightTypes";
import { OWObject } from "../../../../../OW.Remoting/Remoting/DataTypes/OWObject";
import { IBussyAwaitable, IDataLoadingAwaitable, IValidatable, IValidationResult } from "../../../../UI.BaseControls/ControlInterfaces";
import { EditableControl } from "../../../../UI.BaseControls/EditableControl";
import { registerCustomElement } from "../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IVersioned } from "../../Controls/ControlInterfaces";
import { LOVEdit as BaseLovEdit } from "../../Controls/LOVEdit";

const logger = LazyLoadingSectionLogger.create(LoggingSection.lOVEdit);

export class LOVEdit extends EditableControl implements IBussyAwaitable, IDataLoadingAwaitable, IVersioned {
    private _lovedit: BaseLovEdit;
    private _readVersioned: boolean;

    public override readonly validityChanged = new Event<IValidatable, IValidationResult>();

    public set actualObject(v: OWObject) {
        this._lovedit.actualObject = v;
    }

    public get actualObject(): OWObject {
        return this._lovedit.actualObject;
    }

    public get lovEdit(): BaseLovEdit {
        return this._lovedit;
    }

    public get readVersioned(): boolean {
        return this._readVersioned;
    }

    public set readVersioned(value: boolean) {
        this._readVersioned = value;
    }

    /**
     * Umožňuje čekat na běžící procesy na komponentě
     */
    public waitForPendingActions(): Promise<void> {
        return this._lovedit.waitForPendingActions();
    }

    public waitForActualObjectSet(): Promise<boolean> {
        return this._lovedit.waitForActualObjectSet();
    }

    /**
     * Umožňuje čekat na dočtení dat
     */
    public async waitOnDataLoaded(): Promise<boolean> {
        return this._lovedit.waitOnDataLoaded();
    }
    /**
     * Umožňuje zrušit běžící procesy na komponentě
     */
    public cancelPendingActions(): void {
        this._lovedit.cancelPendingActions();
    }

    public override set value(v: any) {
        this._lovedit.controlValue = v;
    }

    public override get value(): any {
        //return this.lovedit.LastObject;
        return this._lovedit.controlValue;
    }

    public override get displayedValue(): ITextBuilder {
        if (this._lovedit.innerElement instanceof HTMLInputElement)
            return this._lovedit.innerElement.value;

        return this.value;
    }

    public override set displayedValue(v: ITextBuilder) {
        if (this._lovedit.innerElement instanceof HTMLInputElement)
            this._lovedit.innerElement.value = v.toString();

        this.value = v;
    }

    public override set enabled(value: boolean) {
        this.lovEdit.enabled = value;
        super.enabled = value;
    }

    public override get enabled(): boolean {
        return super.enabled;
    }

    public override setValid(): void {
        super.setValid();
        this.lovEdit.setValid();
    }

    public override setInvalid(locKey: string, message: string = null): void {
        super.setInvalid(locKey, message);
        this.lovEdit.setInvalid(locKey, message);
    }

    protected override _constructor(): void {
        super._constructor();

        this._innerElement = document.createElement("div");
        this.appendChild(this._innerElement);
        this.classList.add("LOVEdit");
    }

    public setInnerAttribute(attrName: string, val: string): void {
        if (val == undefined)
            return;

        this.setAttribute(attrName, val);
        this._innerElement.setAttribute(attrName, val);
    }

    protected override attributeChangedCallback(attrName: string, oldVal: string, newVal: string): void {
        super.attributeChangedCallback(attrName, oldVal, newVal);
        // TODO: pokud se mají nějaké atributy zpracovávat, tak je nutné je vyjmenovat v get observedAttributes()!
        this._innerElement.setAttribute(attrName, newVal);
    }

    /**
     * Vytvoří LOVEdit
     * @param defaultWhisperer Chování porovnávání řetězců v našeptávači
     */
    public renderLov(defaultWhisperer?: string): void {
        this._lovedit = new BaseLovEdit({
            element: this._innerElement,
            originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION,
            defaultWhisperer,
        });
        this._lovedit.readVersioned = this._readVersioned;
        this._lovedit.validityChanged.add((_el, validity) =>
            this.validityChanged.trigger(this, validity));
        this._lovedit.isEditing = true;

        this._lovedit.valueChanged.add((s, e) => {
            logger.log(s, e);
            //ElementUtils.callEvent(parentItem, "valuechanged", { value: numedit.controlValue, column: column });
            this.callEvent("change");
        });
    }

    /**
     * preda focus na LOVEdit
     */
    public override focus(): void {
        this._lovedit.focus();
    }
}

registerCustomElement("tsc-lovedit", LOVEdit);
